// Display overrides for disease names. The shared MongoDB Atlas DB may still
// store the clinical term (e.g. "Dyslipidemia"), but we want the public site
// to show the friendlier patient-facing term. Keyed by slug.
const OVERRIDES = {
  dyslipidemia: "High Cholesterol Levels",
};

/**
 * Pretty disease name for display.
 * @param {{ slug?: string, name?: string } | undefined} disease
 * @returns {string}
 */
export function displayDiseaseName(disease) {
  if (!disease) return "";
  const slug = disease.slug;
  if (slug && OVERRIDES[slug]) return OVERRIDES[slug];
  return disease.name || slug || "";
}

/**
 * Pretty disease name when only the slug (or raw id) is available.
 * @param {string} slug
 * @param {Array<{ slug?: string, id?: string, name?: string }>=} diseases
 * @returns {string}
 */
export function displayDiseaseNameBySlug(slug, diseases = []) {
  if (!slug) return "";
  if (OVERRIDES[slug]) return OVERRIDES[slug];
  const match = diseases.find((d) => d.slug === slug || d.id === slug);
  return match ? match.name : slug;
}
